import { SettingsOptionsKi } from '../domain/settingsOptionsKi';

// 検索条件項目のデフォルトデータ
export const settingsOptionsKiDefaultValue: SettingsOptionsKi = {
  searchCondition: {
    makers: [],
    kiList: [],
    kiTagList: [],
    shuGroupList: [],
    shuList: [],
    areas: [],
    halls: [],
    sisTypes: [],
    latestBaseDateForDailySisData: '',
    latestBaseDateForWeeklySisData: '',
    latestBaseDateForMonthlySisData: '',
  },
  markings: [],
  filters: [],
  fields: {
    ki: [],
    dai: [],
    kasidama: [],
    marketAreaGraph: [],
  },
  genres: {
    ki: [],
    dai: [],
    kasidama: [],
  },
};
